// Deutsch für das Terminologie-Panel. Schweizer Hochdeutsch: «ss» statt «ß», Sie-Form,
// «Guillemets». «Save», «Cancel» und «Edit» stehen im gemeinsamen Vokabular (i18n/common.de.ts)
// und werden hier bewusst nicht erneut registriert.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Terminology': 'Terminologie',
  'The words this engagement uses. Every translation carries them; changing one retranslates what the machine wrote, and leaves what you wrote alone.': 'Die Wörter, die dieser Auftrag verwendet. Jede Übersetzung führt sie mit; ändert man eines, wird neu übersetzt, was die Maschine geschrieben hat – was Sie geschrieben haben, bleibt unangetastet.',
  'Propose terms from this engagement': 'Begriffe aus diesem Auftrag vorschlagen',
  'Reading the documents…': 'Dokumente werden gelesen …',
  'Proposed — nothing here affects a translation until you activate it': 'Vorgeschlagen – nichts davon wirkt sich auf eine Übersetzung aus, bis Sie es aktivieren',
  'In use': 'In Verwendung',
  'No terms yet — every translation is made without a shared vocabulary.': 'Noch keine Begriffe – jede Übersetzung entsteht ohne gemeinsames Vokabular.',
  'Activate': 'Aktivieren',
  'Discard': 'Verwerfen',
  'Retire': 'Ausser Kraft setzen',
  'Put back in use': 'Wieder in Verwendung nehmen',
  'Add the term': 'Begriff hinzufügen',
  'Never translate this term — it reads the same in every language': 'Diesen Begriff nie übersetzen – er lautet in jeder Sprache gleich',
  'Hide retired terms': 'Ausser Kraft gesetzte Begriffe ausblenden',
  '{n} retired term': '{n} ausser Kraft gesetzter Begriff',
  '{n} retired terms': '{n} ausser Kraft gesetzte Begriffe',
  'Proposed by the terminology pass over this engagement’s own documents': 'Vom Terminologielauf über die Dokumente dieses Auftrags vorgeschlagen',
  'Written by an operator': 'Von einer Bearbeiterin oder einem Bearbeiter erfasst',
  'seeded term': 'vorgeschlagen',
  'operator term': 'erfasst',
  '{done} of {expected} translations in place': '{done} von {expected} Übersetzungen vorhanden',
  '{n} still to come': '{n} stehen noch aus',
  '{n} corrected by hand': '{n} von Hand korrigiert',
  '{n} need your review — the source changed after you corrected them': '{n} brauchen Ihre Prüfung – die Quelle hat sich nach Ihrer Korrektur geändert',
  '{n} miss a term': 'bei {n} fehlt ein Begriff',
}, 'TerminologyPanel');
